



















import { computed, defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { useDeleteField } from '@/store/modules/fields';
import { Field } from '@/store/types';

export default defineComponent({
	components: { ConfirmDialog },
	inheritAttrs: false,
	props: {
		field: {
			type: Object as () => Field,
			required: true,
		},
	},
	setup(props, { root }) {
		const showConfirmationDialog = ref<boolean>(false);
		const { deleteField, clearError, isLoading, hasError, error: deleteError } = useDeleteField(root.$store);
		const error = computed<string>(
			() =>
				deleteError.value?.response?.data?.message ||
				'An error occurred while attempting to delete a field. Please try again.'
		);

		const handleConfirmDelete = async () => {
			clearError();

			const success = await deleteField(props.field.id);

			if (success) {
				root.$store.dispatch('resources/getAllResources');
				showConfirmationDialog.value = false;
			}
		};

		return {
			showConfirmationDialog,
			handleConfirmDelete,
			clearError,
			isLoading,
			hasError,
			error,
		};
	},
});
